export const collaboratorsLocale = {
   title: '협력자',
   code: "추천 코드",
   link: "link",
   number_people_invited: "초대된 사용자 수",
   level: "Level",
   balance_received: "받지 않은 잔액",
   register_withdraw: "인출 등록",
   list_user_invite: '초대된 사용자 리스트',
   search: 'search',
   stt: '순번',
   time: '시간',
   mail: 'mail',
   kyc: 'kyc',
   withdrawal_history: '인출 내역',
   amount: '금액',
   token_type: '토큰 유형',
   status: '상태',
   register_title: '협력자가 되기 위해 등록하기',
   register_content: '아래 확인 버튼을 클릭하면 AIS의 협력자 프로그램 참여에 동의하게 됩니다.',
   confirm_register: '확인',
   close_register: '취소',
   withdraw_all: '모두 인출',
   withdraw_landmark: '랜드마크별 인출',
   money: '금액',
   money_remaining: '남은 금액',
   withdrawal_fee: '인출 수수료',
   bonus_draw_milestone: '보너스 추첨 이정표 ( 리퍼러 ) ',
   withdraw_content: '사용자는 현재 레벨 또는 전체 금액에 따라 돈을 인출하도록 선택할 수 있습니다. 인출 시 추천인의 레벨 및 횟수가 초기화 됩니다. 전액 출금 시 2000 STN-A의 수수료가 부과됩니다.',
   unknown_error: '오류가 발생 했습니다. 잠시 후 다시 시도 해 주세요.',
   oops: '죄송합니다!',
   ok: 'OK',
};
